import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlayerService } from '../../services/player.service';
import { GlobalService } from '../../services/global.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DialogService } from '../../services/dialog.service';
// import SwipeListener from 'swipe-listener';
import { UserService } from 'src/app/services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../services/api.service';


@Component({
    selector: 'sd-player',
    templateUrl: './player.component.html',
    styleUrls: ['./player.component.scss']
})

export class PlayerComponent implements AfterViewInit {

    showQueue: Boolean = false;
    colorStyle = '';
    textStyle = '';
    oldUrl = '';
    imgSrc = '../../../assets/image/player/play-light.svg'

    constructor(
        public player: PlayerService,
        public global: GlobalService,
        public dialog: DialogService,
        public router: Router,
        public user: UserService,
        private api: ApiService
    ) {
    }

    async ngDoCheck() {
        if (this.global.isBrowser &&
            this.player.playlist.length > 0 &&
            this.player.myPlaylist != undefined && this.player.myPlaylist != null &&
            this.player.playlist[this.player.myPlaylist.current].image &&
            this.oldUrl !== this.player.playlist[this.player.myPlaylist.current].image) {

            const Vibrant = require('node-vibrant');

            try {
                const colorVibrantObject = new Vibrant(this.player.playlist[this.player.myPlaylist.current].image);
                const colorMap = await colorVibrantObject.getPalette();
                this.textStyle = colorMap.LightVibrant.hex;
                this.colorStyle = colorMap.DarkMuted.hex;
                // this.oldUrl = this.player.playlist[this.player.myPlaylist.current].image;
            } catch (error) {
                // console.log(error);
                // console.log(this.player.playlist[this.player.myPlaylist.current]);
            }
            this.oldUrl = this.player.playlist[this.player.myPlaylist.current].image;
        }
    }

    ngAfterViewInit() {
        // if (this.global.isBrowser && this.global.isMobile() && this.player.myPlaylist!=undefined && this.player.myPlaylist!=null) {
        //     const container = document.getElementById('jp_container_N');
        //     const listener = SwipeListener(container);
        //     container.addEventListener('swipe', (e: any) => {
        //         if (e.detail.directions.top) {
        //             this.router.navigate( ['/' + this.global.songDetailPrefix + '/' +
        //              this.player.playlist[this.player.myPlaylist.current].slug]);
        //         }
        //     });
        // }

    }

    changeSeekPos(event) {
        if (this.global.isBrowser) {
            const angularthis = this;
            angularthis.global.trackEvent('player-play', 'Seek');
            // console.log(event);
            angularthis.player.currentTime = event.value;
            (<any>$(angularthis.player.cssSelector.jPlayer)).jPlayer('play', event.value);
        }
    }

    roundOff(num) {
        return Math.round(num);
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.player.playlist, event.previousIndex, event.currentIndex);
        moveItemInArray(this.player.myPlaylist.original, event.previousIndex, event.currentIndex);
        moveItemInArray(this.player.myPlaylist.playlist, event.previousIndex, event.currentIndex);

        if (this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
            if (event.previousIndex === this.player.myPlaylist.current) {
                this.player.myPlaylist.current = event.currentIndex;
            } else if ((event.previousIndex < this.player.myPlaylist.current) && (event.currentIndex >= this.player.myPlaylist.current)) {
                this.player.myPlaylist.current--;
            } else if ((event.previousIndex > this.player.myPlaylist.current) && (event.currentIndex <= this.player.myPlaylist.current)) {
                this.player.myPlaylist.current++;
            }
        }
    }

    toggleQueue() {
        if (this.global.isBrowser) {
            $('.queue').toggleClass('active');
        }
    }

    onMouseOver() {
        this.imgSrc = '../../../assets/image/player/play-dark.svg'

    }

    onMouseOut() {
        this.imgSrc = '../../../assets/image/player/play-light.svg'

    }
}
